import { Dispatch } from 'react';
import { RESEND_ACTIVATION_EMAIL, ResendActivationEmailAction } from '../types';
import { postResendActivationEmail } from '../../../../services/EmailApi';

const Log = console.log;

export const resendActivationEmail = (email: string): ((dispatch: Dispatch<ResendActivationEmailAction>) => void) => {
    return async (dispatch: Dispatch<ResendActivationEmailAction>) => {
        try {
            await postResendActivationEmail(email);
            dispatch(receiverResendActivationEmail());
        } catch (error) {
            Log(error?.message);
        }
    };
};

const receiverResendActivationEmail = (): ResendActivationEmailAction => {
    return {
        type: RESEND_ACTIVATION_EMAIL,
        payload: true,
    };
};
